<template>
  <div class="perReset" >
    <el-card class="card-flex">
      <div>
        <el-row>
          <el-col class="title">
            <div class="grid-content bg-purple-dark">人员&nbsp;/&nbsp;公司管理</div>
          </el-col>
        </el-row>
        <el-row class="button-line" style="display: flex;justify-content: left;align-items: center;">
          <el-button plain size="medium" @click="servicerBind">服务人员绑定</el-button>
          <el-button class="btn-left" plain size="medium" @click="clearUserBind">清除人员绑定</el-button>
          <el-button class="btn-left" plain size="medium" @click="checkAreaCompany">园区企业检查</el-button>
          <el-button class="btn-left" plain size="medium" @click="checkNotExistCompany">筛选未知公司</el-button>
          <el-button class="btn-left" plain size="medium" @click="batchUpdateServiceDate">更改服务时间</el-button>
          <!-- <el-cascader
            class="btn-left"
            ref="salerInput"
            v-model="adminId"
            placeholder="请选择业务人员"
            :options="adminOptions"
            size="medium"
            :props="{ expandTrigger: 'hover', emitPath: false, multiple: true }"
            clearable
            filterable
            @visible-change="handleVisibleChange($event, 'salerInput')"
          >
          </el-cascader> -->
          <el-select 
            class="btn-left" 
            v-model="adminId" 
            filterable 
            placeholder="选择业务人员" 
            clearable 
            size="medium">
            <el-option
              v-for="admin in admins"
              :key="admin.id"
              :label="admin.username"
              :value="admin.id">
            </el-option>
          </el-select>
          <el-button class="btn-left" plain size="medium" @click="handelResetSaler">替换公司业务</el-button>
        </el-row>
      </div>
    </el-card>
    <el-card>
      <div>
        <el-row>
          <el-col class="title">
            <div class="grid-content bg-purple-dark">通知&nbsp;/&nbsp;工具管理</div>
          </el-col>
        </el-row>
        <el-row style="display: flex;justify-content: left;align-items: center;">
            <el-upload action="#" :headers="uploadHeader" :http-request="handelTest">
              <el-button plain size="medium">图像识别测试</el-button>
            </el-upload>
            <el-upload action="#" :headers="uploadHeader" :http-request="submitStatus">
              <el-button class="btn-left" plain size="medium">未结订单状态</el-button>
            </el-upload>
            <el-upload action="#" :headers="uploadHeader" :http-request="handelComebackSend">
              <el-button class="btn-left" style="padding: 10px 30px;" plain size="medium">复工通知</el-button>
            </el-upload>
            <el-upload action="#" :headers="uploadHeader" :http-request="handelSend">
              <el-button class="btn-left" style="padding: 10px 30px;" plain size="medium">短信群发</el-button>
            </el-upload>
            <el-upload action="#" :headers="uploadHeader" :http-request="handelBsSend">
              <el-button class="btn-left" style="padding: 10px 30px;" plain size="medium">报税通知</el-button>
            </el-upload>
            <el-upload action="#" :headers="uploadHeader" :http-request="handelFestivalSend">
              <el-button class="btn-left" style="padding: 10px 30px;" plain size="medium">节日通知</el-button>
            </el-upload>
        </el-row>
      </div>
    </el-card>    
    <el-drawer title="筛选不存在公司" :visible.sync="notExistCompanyDrawer" direction="rtl" size="50%" :before-close="handleCompanyInfoBeforeClose">
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-form
          :model="itemForm"
          label-width="100px"
          size="mini"
        >
          <el-form-item label="批量筛选公司">
            <el-input
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 6 }"
              placeholder="请输入筛选的公司，一行一个"
              v-model="itemForm.companyList"
            >
            </el-input>
          </el-form-item>
          <el-form-item v-if="showNotExistCom === true" label="不存在的公司">
            <el-input type="textarea" v-model="notExistsCom">{{ notExistsCom }}</el-input>
          </el-form-item>
        </el-form>
        <el-row style="padding-top: 0.4rem; padding-bottom: 2rem; float: right">
          <el-col>
            <el-button
              type="primary"
              size="mini"
              @click="submitCheck"
              >提交</el-button
            >
          </el-col>
        </el-row>
      </div>
    </el-drawer>
    <el-dialog title="数据筛选中" :visible.sync="checkingDrawer">
      <el-progress :percentage="filePercentage" color="blue"></el-progress>
    </el-dialog>
    <el-drawer title="园区企业检查" :visible.sync="areaCompanyDrawer" direction="rtl" size="50%" :before-close="handleCompanyInfoBeforeClose">
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-form
          :model="areaForm"
          label-width="100px"
          size="mini"
        >
          <el-form-item label="园区企业检查">
            <el-input
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 6 }"
              placeholder="请输入筛选的公司，一行一个"
              v-model="areaForm.companyList"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="选择所属园区">
            <el-cascader v-model="areaForm.areaAddress" clearable :options="areaAddress" size="mini"
              :props="{ expandTrigger: 'hover' }">
            </el-cascader>
          </el-form-item>
          <el-form-item v-if="showNotExistAreaCom === true" label="不存在园区的公司">
            <el-input type="textarea" v-model="notAreaExistsCom">{{ notAreaExistsCom }}</el-input>
          </el-form-item>
          <el-form-item v-if="showNotMatchAreaCom === true" label="不匹配园区的公司">
            <el-input type="textarea" v-model="notAreaMatchCom">{{ notAreaMatchCom }}</el-input>
          </el-form-item>
        </el-form>
        <el-row style="padding-top: 0.4rem; padding-bottom: 2rem; float: right">
          <el-col>
            <el-button
              type="primary"
              size="mini"
              @click="submitCheckAreaCompany"
              >提交</el-button
            >
          </el-col>
        </el-row>
      </div>
    </el-drawer>
    <el-drawer title="清除人员绑定" :visible.sync="clearUserBindDrawer" direction="rtl" size="50%" :before-close="handleCompanyInfoBeforeClose">
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-form
          :model="clearUserBin"
          label-width="100px"
          size="mini"
        >
          <el-form-item label="选择解绑人员">
            <el-tag
              v-for="tag in dynamicTags"
              :key="tag.id"
              closable
              :disable-transitions="false"
              @close="handleClose(tag.id)"
            >{{ tag.username }}</el-tag>
            <el-select
              v-if="inputVisible"
              ref="saveTagInput"
              class="input-new-tag"
              v-model="clearUserBin.clearer"
              multiple
              placeholder="请选择人员"
              style="width: 100%"
              size="mini"
              filterable
              @focus="onBlur"
              @change="setSelectStatus"
            >
              <el-option v-for="item in admins" :key="item.id" :label="item.username"
                :value="item.id">
              </el-option>
            </el-select>
            <el-button v-else class="button-new-tag" size="small" @click="showInput">+新增</el-button>
          </el-form-item>
          <el-form-item label="批量选择角色">
            <el-checkbox-group v-model="clearUserBin.roleer">
              <el-checkbox
                  v-for="role in roles"
                  :label="role.id"
                  :key="role.id"
                  >{{ role.name }}
                </el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-form>
        <el-row style="padding-top: 0.4rem; padding-bottom: 2rem; float: right">
          <el-col>
            <el-button
              type="primary"
              size="mini"
              @click="submitClearUserBind"
              >提交</el-button
            >
          </el-col>
        </el-row>
      </div>
    </el-drawer>
    <el-drawer title="批量更改公司服务起止日期" :visible.sync="batchUpdateServiceDateDrawer" direction="rtl" size="50%" :before-close="handleCompanyInfoBeforeClose">
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-form
          :model="batchList"
          label-width="100px"
          size="mini"
        >
          <el-form-item label="批量筛选公司">
            <el-input
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 6 }"
              placeholder="请输入筛选的公司，一行一个"
              v-model="batchList.companyList"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="服务起止日期">
            <el-date-picker
              v-model="batchList.syncDate"
              type="monthrange"
              range-separator="至"
              start-placeholder="开始月份"
              end-placeholder="结束月份">
            </el-date-picker>
          </el-form-item>
        </el-form>
        <el-row style="padding-top: 0.4rem; padding-bottom: 2rem; float: right">
          <el-col>
            <el-button
              type="primary"
              size="mini"
              @click="submitBatchUpdateServiceDate"
              >提交</el-button
            >
          </el-col>
        </el-row>
      </div>
    </el-drawer>
    <el-drawer title="服务人员绑定" :visible.sync="servicerBindDrawer" direction="rtl" size="50%" :before-close="handleCompanyInfoBeforeClose">
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-card shadow="always" style="margin-bottom: .2rem;">
          <div slot="header" class="clearfix">
              <span>第一步：筛选不存在的公司</span>
            </div>
        <el-form
          :model="servicer"
          label-width="110px"
          size="mini"
        >
          <el-form-item label="批量关联公司">
            <el-input
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 6 }"
              placeholder="请输入关联的公司，一行一个"
              v-model="servicer.companyList"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="对比财务登记表">
            <el-radio-group v-model="servicer.is_comfiscal" size="mini">
                <el-radio-button label="y">是</el-radio-button>
                <el-radio-button label="n">否</el-radio-button>
              </el-radio-group>
          </el-form-item>
          <el-form-item v-if="showNotExistCom === true" label="不存在的公司">
            <el-input type="textarea" :readonly="true" v-model="notExistsCom">{{ notExistsCom }}</el-input>
            <span v-if="notExistsCom != ''" style="color: red;">*请检查不存在的【{{ notExistsComCount }}】家公司，核对后再进行第二步绑定操作！</span>
          </el-form-item>
          <el-form-item v-if="showNotExistComfiscal === true" label="不存在财务登记表的公司">
            <el-input type="textarea" :readonly="true" v-model="notExistComficsal">{{ notExistComficsal }}</el-input>
            <span v-if="notExistComficsal != ''" style="color: red;">*不存在财务登记表的【{{ notExistComficsalCount }}】家公司，可点击下方添加按钮，核对后再进行第二步绑定操作！</span>
          </el-form-item>
          <el-form-item v-if="showNotExistComfiscal === true" label="写入财务登记表">
            <el-button
              type="primary"
              size="mini"
              @click="submitAddComfical(notExistComficsal)"
              >添加</el-button
            >
          </el-form-item>
        </el-form>
        <el-row style="padding-top: 0.4rem; padding-bottom: .6rem; float: right">
          <el-col>
            <el-button
              type="primary"
              size="mini"
              @click="submitCheckService"
              >查询</el-button
            >
          </el-col>
        </el-row>
      </el-card>
      <el-card shadow="always">
        <div slot="header" class="clearfix">
          <span>第二步：绑定人员</span>
        </div>
        <el-row style="margin-bottom: .4rem;">
          <el-col :span="4" class="m-label" style="line-height: 28px;">财税负责人</el-col>
          <el-col :span="7">
            <el-select v-model="servicer.leader_id" multiple filterable placeholder="选择财税负责人" clearable size="mini">
              <el-option
                v-for="admin in admins"
                :key="admin.id"
                :label="admin.username"
                :value="admin.id">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="4" :offset="2" class="m-label" style="line-height: 28px;">理票会计</el-col>
          <el-col :span="7">
            <el-select v-model="servicer.acc_id" multiple filterable placeholder="选择理票会计" clearable size="mini">
              <el-option
                v-for="admin in admins"
                :key="admin.id"
                :label="admin.username"
                :value="admin.id">
              </el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row style="margin-bottom: .4rem;">
          <el-col :span="4" class="m-label" style="line-height: 28px;">记账报税会计</el-col>
          <el-col :span="7">
            <el-select v-model="servicer.advisory_id" multiple filterable placeholder="选择记账报税会计" clearable size="mini">
              <el-option
                v-for="admin in admins"
                :key="admin.id"
                :label="admin.username"
                :value="admin.id">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="4" :offset="2" style="line-height: 28px;">开票会计</el-col>
          <el-col :span="7">
            <el-select v-model="servicer.invoice_id" multiple filterable placeholder="选择开票会计" clearable size="mini">
              <el-option
                v-for="admin in admins"
                :key="admin.id"
                :label="admin.username"
                :value="admin.id">
              </el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row style="margin-bottom: .4rem;">
          <el-col :span="4" style="line-height: 28px;">客服会计</el-col>
          <el-col :span="7">
            <el-select v-model="servicer.ass_id" multiple filterable placeholder="选择客服会计" clearable size="mini">
              <el-option
                v-for="admin in admins"
                :key="admin.id"
                :label="admin.username"
                :value="admin.id">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="4" :offset="2" style="line-height: 28px;">业务人员</el-col>
          <el-col :span="7">
            <el-select v-model="servicer.saler_id" multiple filterable placeholder="选择业务人员" clearable size="mini">
              <el-option
                v-for="admin in admins"
                :key="admin.id"
                :label="admin.username"
                :value="admin.id">
              </el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row style="margin-bottom: .4rem;">
          <el-col :span="4" style="line-height: 28px;">财税顾问</el-col>
          <el-col :span="7">
            <el-select v-model="servicer.service_advisor_id" multiple filterable placeholder="选择财税顾问" clearable size="mini">
              <el-option
                v-for="admin in admins"
                :key="admin.id"
                :label="admin.username"
                :value="admin.id">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="4" :offset="2" style="line-height: 28px;">综合会计</el-col>
          <el-col :span="7">
            <el-select v-model="servicer.general_accounting" multiple filterable placeholder="选择综合会计" clearable size="mini">
              <el-option
                v-for="admin in admins"
                :key="admin.id"
                :label="admin.username"
                :value="admin.id">
              </el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4" style="line-height: 28px;">共享人员</el-col>
          <el-col :span="20">
            <el-tag
              v-for="tag in dynamicTagss"
              :key="tag.id"
              closable
              :disable-transitions="false"
              @close="handleServerClose(tag.id)"
            >{{ tag.username }}</el-tag>
            <el-select
              v-if="inputServiceVisible"
              ref="saveServiceTagInput"
              class="input-new-tag"
              v-model="servicer.sharer_id"
              multiple
              placeholder="请选择人员"
              style="width: 100%"
              size="mini"
              filterable
              @focus="onServiceBlur"
              @change="setServiceSelectStatus"
            >
              <el-option v-for="item in admins" :key="item.id" :label="item.username"
                :value="item.id">
              </el-option>
            </el-select>
            <el-button v-else class="button-new-tag" size="small" @click="showServiceInput">+新增</el-button>

            <!--             
            <el-select v-model="servicer.sharer_id" filterable multiple placeholder="选择共享人员" style="width: 98%;" clearable size="mini">
              <el-option
                v-for="admin in admins"
                :key="admin.id"
                :label="admin.username"
                :value="admin.id">
              </el-option>
            </el-select> -->

          </el-col>
        </el-row>
        <el-row style="padding-top: 0.4rem; padding-bottom: .6rem; float: right">
          <el-col>
            <el-button
              type="primary"
              size="mini"
              @click="submitCheckServiceUp"
              >提交</el-button
            >
          </el-col>
        </el-row>

      </el-card>
      </div>
    </el-drawer>
  </div>
</template>

<script>
export default {
  name: 'PerReset',
  data () {
    return {

      inputVisible: false,
      inputServiceVisible: false,
      uploadHeader: {Authorization: localStorage.token},
      admins: [],
      adminOptions: [],
      adminId: '',
      notExistCompanyDrawer: false,
      itemForm: {
        companyList: ''
      },
      checkingDrawer: false,
      filePercentage: 0,
      showNotExistCom: false,
      showNotExistComfiscal: false,
      notExistsComCount: 0,
      notExistsCom: '',
      notExistComficsal: '',
      notExistComficsalCount: 0,
      showNotExistAreaCom: false,
      showNotMatchAreaCom: false,
      areaCompanyDrawer: false,
      areaForm: {
        companyList: '',
        areaAddress: ''
      },
      notAreaExistsCom: '',
      notAreaMatchCom: '',
      areaAddress: [],
      clearUserBindDrawer: false,   // 清除人员绑定
      clearUserBin: {
        clearer: [],
        roleer: [],
      },
      roles: [
        {
          id: 'leader_id',
          name: '财税负责人'
        },
        {
          id: 'acc_id',
          name: '理票会计'
        },
        {
          id: 'advisory_id',
          name: '记账报税会计'
        },
        {
          id: 'invoice_id',
          name: '开票会计'
        },
        {
          id: 'ass_id',
          name: '客服会计'
        },
        {
          id: 'service_advisor_id',
          name: '财税顾问'
        },
        {
          id: 'general_accounting',
          name: '综合会计'
        },
        {
          id: 'saler_id',
          name: '业务人员'
        },
        {
          id: 'sharer_id',
          name: '共享人员'
        }
      ],
      timer: null,
      batchUpdateServiceDateDrawer: false,
      batchList: {
        companyList: '',
        syncDate: ''
      },
      servicerBindDrawer: false,
      servicer: {
        companyList: '',
        leader_id: null,
        acc_id: null,
        advisory_id: null,
        invoice_id: null,
        ass_id: null,
        saler_id: null,
        service_advisor_id: null,
        general_accounting: null,
        sharer_id: [],
        is_comfiscal: 'y'
      }
    }
  },
  computed: {
    collapse () {
      return this.$store.state.collapse
    },
    dynamicTags () {
      let arr = []
      this.admins.forEach((item) => {
        this.clearUserBin.clearer.forEach((i) => {
          if (item.id === i)
            arr.push({
              id: i,
              username: item.username,
            })
        })
      })
      return arr
    },
    dynamicTagss () {
      let arr = []
      this.admins.forEach((item) => {
        this.servicer.sharer_id.forEach((i) => {
          if (item.id === i)
            arr.push({
              id: i,
              username: item.username,
            })
        })
      })
      return arr
    },
  },
  methods: {
    handleVisibleChange(visible, field) {
      const refMap = {
        'salerInput': {
          inputRef: 'salerInput',
          callback: this.loadAdmin
        },
      };
      const { inputRef, callback } = refMap[field];
      if (visible) {
        const cascaderInput = this.$refs[inputRef];
        if (cascaderInput && cascaderInput.$refs.input) {
          cascaderInput.$refs.input.focus();
        }
        this.$nextTick(callback);
      }
    },
    loadAdmin() {
      this.$axios
        .get("api/admin/user/branch")
        .then(({ data }) => {
          if (data.code === 1) {
            this.adminOptions = data.data;
          }
        })
        .catch();
    },
    // 服务人员绑定
    servicerBind () {
      this.servicerBindDrawer = true
    },
    submitCheckService () {
      if (!this.servicer.companyList) {
        this.$message.error('请输入要批量绑定的公司！')
        return
      }
      this.$axios.post('/api/admin/local/seek', {list: this.servicer})
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            // console.log(data); return;
            this.$message.success(data.msg)
            if (data.data.notExistCompanyCount > 0) {
              this.showNotExistCom = true
              this.notExistsComCount = data.data.notExistCompanyCount
              this.notExistsCom = data.data.notExistCompany
            } else {
              this.showNotExistCom = false
              this.notExistsComCount = 0
              this.notExistsCom = ''
            }
            if (data.data.notExistComficsalCount) {
              this.showNotExistComfiscal = true
              this.notExistComficsal = data.data.notExistComficsal
              this.notExistComficsalCount = data.data.notExistComficsalCount
            } else {
              this.showNotExistComfiscal = false
              this.notExistComficsal = ''
              this.notExistComficsalCount = 0
            }
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    submitCheckServiceUp () {
      if (!this.servicer.companyList) {
        this.$message.error('请输入要批量绑定的公司！')
        return
      }
      this.$axios.post('/api/admin/batch/bind_company_user', {list: this.servicer})
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.$message.success(data.msg)
            this.showNotExistCom = true
            this.notExistsCom = data.data.notExistCompany
            this.servicer.companyList = ''
            this.servicer.leader_id = null
            this.servicer.acc_id = null
            this.servicer.advisory_id = null
            this.servicer.invoice_id = null
            this.servicer.ass_id = null
            this.servicer.saler_id = null
            this.servicer.service_advisor_id = null
            this.servicer.general_accounting = null
            this.servicer.sharer_id = []
            this.servicerBindDrawer = false
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    // 批量更改公司服务时间
    batchUpdateServiceDate () {
      this.batchUpdateServiceDateDrawer = true
    },
    submitBatchUpdateServiceDate () {
      if (!this.batchList.companyList) {
        this.$message.error('请输入要批处理的公司！')
        return
      }
      if (this.batchList.syncDate.length === 0) {
        this.$message.error('请选择日期范围！')
        return
      }
      this.$axios.post('/api/admin/batch/update_service_date', {list: this.batchList})
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.$message.success(data.msg)
            this.batchUpdateServiceDateDrawer = false
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    handleClose (id) {
      this.clearUserBin.clearer.forEach((item, index) => {
        if (item === id) this.clearUserBin.clearer.splice(index, 1)
      })
    },
    handleServerClose (id) {
      this.servicer.sharer_id.forEach((item, index) => {
        if (item === id) this.servicer.sharer_id.splice(index, 1)
      })
    },
    setSelectStatus () {
      this.inputVisible = false
    },
    onBlur() {
      this.$refs.saveTagInput.$refs.input.blur = () => {
        this.inputVisible = false
      }
    },
    showInput () {
      this.inputVisible = true
      this.$nextTick((_) => {
        this.$refs.saveTagInput.$refs.input.focus()
      })
    },
    setServiceSelectStatus () {
      this.inputServiceVisible = false
    },
    onServiceBlur() {
      this.$refs.saveServiceTagInput.$refs.input.blur = () => {
        this.inputServiceVisible = false
      }
    },
    showServiceInput () {
      this.inputServiceVisible = true
      this.$nextTick((_) => {
        this.$refs.saveServiceTagInput.$refs.input.focus()
      })
    },
    // 批量添加不存在财务登记表的公司
    submitAddComfical(row) {
      this.$confirm('确定要添加当前不存在财务登记表的公司吗？', '提示',  {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post('/api/admin/company/add_comfical_company', {batch_company: row}).then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.$message.success(data.msg)
          } else {
            this.$message.error(data.msg)
          }
        })
      }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消！',
          })
      })
    },
    // 清除人员绑定
    clearUserBind () {
      this.clearUserBindDrawer = true
    },
    submitClearUserBind () {
      this.$axios.post('/api/admin/clear/user_bind', {list: this.clearUserBin})
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.$message.success(data.msg)
            this.clearUserBin.clearer = []
            this.clearUserBin.roleer = []
            this.clearUserBindDrawer = false
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    // 园区企业检查
    checkAreaCompany () {
      this.areaCompanyDrawer = true
      this.$axios
        .get('/api/admin/get_areas')
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.areaAddress = data.data.areas
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    submitCheckAreaCompany () {
      this.$axios.post('/api/admin/company/check_area', {list: this.areaForm})
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.$message.success(data.msg)
            this.showNotExistAreaCom = true
            this.showNotMatchAreaCom = true
            this.notAreaExistsCom = data.data.notExistAreaCom
            this.notAreaMatchCom = data.data.notMatchAreaCom
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    // 筛选不存在公司
    checkNotExistCompany () {
      this.notExistCompanyDrawer = true
    },
    submitCheck () {
      if (!this.itemForm.companyList) {
        this.$message.error('请输入要筛查的公司信息！')
        return
      }
      this.filePercentage = 0
      this.checkingDrawer = true
      this.timer = setInterval(() => {
        if (this.filePercentage > 78) {
            this.filePercentage = 99
            this.$axios.post('/api/admin/company/check', {list: this.itemForm})
            .then((res) => {
              const { data } = res
              if (data.code === 0) {
                this.filePercentage = 100
                this.checkingDrawer = false
                this.showNotExistCom = true
                this.notExistsCom = data.data.notExistCompany
                clearInterval(this.timer)
              } else {
                this.$message.error(data.msg)
              }
            }).catch((error) => {
              this.$message.error(error)
              clearInterval(this.timer);
            })
        }
        else {
          this.filePercentage += this.getRandom(10, 20)
        }
      }, 1000)
    },
    getRandom(min, max) {
      return Math.round(Math.random() * (max - min) + min)
    },
    handleCompanyInfoBeforeClose (done) {
      this.$confirm('确认关闭?')
        .then((_) => {
          this.itemForm.companyList = ''
          this.notExistsCom = ''
          this.filePercentage = 0
          this.areaForm.companyList = ''
          this.notAreaExistsCom = ''
          this.showNotExistCom = false
          this.showNotExistAreaCom = false
          this.showNotMatchAreaCom = false
          this.clearUserBin.clearer = []
          this.clearUserBin.roleer = []
          this.batchList.companyList = ''
          this.batchList.syncDate = ''
          this.servicer.companyList = ''
          this.servicer.is_comfiscal = 'y'
          done()
        })
        .catch((_) => {})
    },
    getPageData () {
      this.$axios.get('/api/admin/per_resets')
        .then((res) => {
          let { data } = res
          if (data.code === 0) {
            this.admins = data.data.admins
          }
        })
    },
    submitClear (res, file, fileList) {
      if (res.code === 0) {
        this.$message.success(res.msg)
      } else {
        this.$message.error(res.msg)
      }
    },
    submitNotExists (options) {
      let formData = new FormData()
      formData.append('file', options.file)
      this.$axios.post('/api/admin/per_reset/comNotExists', formData, {responseType: 'blob'})
        .then((res) => {
          let blob = new Blob([res.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'})
          let objectUrl = window.URL.createObjectURL(blob)
          let link = document.createElement('a')
          link.href = objectUrl
          link.download = '系统不存在企业.xlsx'
          link.click()
          setTimeout(function () {
            window.URL.revokeObjectURL(objectUrl)
          }, 100)
        })
    },
    submitBind (res, file, fileList) {
      if (res.code === 0) {
        this.$message.success(res.msg)
      } else {
        this.$message.error(res.msg)
      }
    },
    submitStatus (options) {
      let formData = new FormData()
      formData.append('file', options.file)
      this.$axios.post('/api/admin/per_reset/orderStatus', formData, {responseType: 'blob'})
        .then((res) => {
          let blob = new Blob([res.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'})
          let objectUrl = window.URL.createObjectURL(blob)
          let link = document.createElement('a')
          link.href = objectUrl
          link.download = '未结订单状态.xlsx'
          link.click()
          setTimeout(function () {
            window.URL.revokeObjectURL(objectUrl)
          }, 100)
        })
    },
    handelTest (options) {
      let formData = new FormData()
      formData.append('file', options.file)
      this.$axios.post('/api/admin/per_reset/ocrTest', formData)
        .then((res) => {
          let { data } = res
          if (data.code === 0) {
            this.$message.success('公司名称：' + data.data.companyName + '\n' + '申报状态：' + data.data.declareStatus + '\n' + '申报时间：' + data.data.declareAt)
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    handelSend (options) {
      let formData = new FormData()
      formData.append('file', options.file)
      this.$axios.post('/api/admin/per_reset/sendSmsBatch', formData)
        .then((res) => {
          let { data } = res
          if (data.code === 0) {
            this.$message.success(data.msg)
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    handelBsSend (options) {
      let formData = new FormData()
      formData.append('file', options.file)
      this.$axios.post('/api/admin/per_reset/sendSmsBsBatch', formData)
        .then((res) => {
          let { data } = res
          if (data.code === 0) {
            this.$message.success(data.msg)
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    handelFestivalSend (options) {
      let formData = new FormData()
      formData.append('file', options.file)
      this.$axios.post('/api/admin/per_reset/sendFestival', formData)
        .then((res) => {
          let { data } = res
          if (data.code === 0) {
            this.$message.success(data.msg)
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    handelComebackSend (options) {
      let formData = new FormData()
      formData.append('file', options.file)
      this.$axios.post('/api/admin/per_reset/sendComeback', formData)
        .then((res) => {
          let { data } = res
          if (data.code === 0) {
            this.$message.success(data.msg)
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    handelResetSaler () {
      if (!this.adminId) {
        this.$message.error('请选择公司业务人员')
        return
      }

      this.$axios.post('/api/admin/per_resets/reset_saler', {adminId: this.adminId})
        .then((res) => {
          let { data } = res
          if (data.code === 0) {
            this.$message.success(data.msg)
          }
        })
    }
  },
  mounted () {
    this.getPageData()
  }
}
</script>

<style lang="stylus" scoped>
  @import '~styles/varibles.styl'
  @import '~styles/vertical.styl'
  .perReset
    marginLeft()

  .button-line {
    margin-bottom: 0.2rem;
  }
  .el-drawer__wrapper >>> .el-drawer {
    overflow-y: auto;
  }

  .card-flex {
    margin-bottom: 0.2rem;
  }

  .el-tag {
    margin: 0.04rem;
  }

  .title {
    height: 0.3rem;
    font-size: 16px;
    margin-bottom: 0.2rem;
    color: #4d84fe;
    font-weight: bold;
  }

  .btn-left {
    margin-left : .2rem;
  }

  .el-dialog .el-select {
    width: 100%;
    .el-tag {
      margin-left: 10px;
    }
    .button-new-tag {
      margin-left: 10px;
      height: 32px;
      line-height: 30px;
      padding-top: 0;
      padding-bottom: 0;
    }

    .input-new-tag {
      width: 90px;
      margin-left: 10px;
      vertical-align: bottom;
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/per_reset/PerReset.vue